import * as Yup from 'yup'
import { TFunction } from 'i18next'

export const schema = (t: TFunction) => () =>
  Yup.object().shape(
    {
      ValidationStatus: Yup.number().required(t('global.requiredField')),
    }
  )
